var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiAlarmWarningFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3100_23149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33318 16.6641V11.6641C3.33318 9.89595 4.03556 8.20026 5.2858 6.95002C6.53604 5.69977 8.23173 4.9974 9.99984 4.9974C11.768 4.9974 13.4636 5.69977 14.7139 6.95002C15.9641 8.20026 16.6665 9.89595 16.6665 11.6641V16.6641H17.4998V18.3307H2.49984V16.6641H3.33318ZM4.99984 11.6641H6.66651C6.66651 10.78 7.0177 9.93216 7.64282 9.30704C8.26794 8.68192 9.11579 8.33073 9.99984 8.33073V6.66406C8.67376 6.66406 7.40199 7.19085 6.46431 8.12853C5.52663 9.06621 4.99984 10.338 4.99984 11.6641ZM9.16651 1.66406H10.8332V4.16406H9.16651V1.66406ZM16.4815 4.00406L17.6598 5.1824L15.8932 6.9499L14.714 5.77156L16.4815 4.00406ZM2.33984 5.1824L3.51818 4.00406L5.28568 5.77073L4.10818 6.95073L2.33984 5.1824Z",
    fill: "#FF6833"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3100_23149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiAlarmWarningFill);
export default __webpack_public_path__ + "static/media/ri-alarm-warning-fill.46a19736e6c6a61f0e86a72e92906b8c.svg";
export { ForwardRef as ReactComponent };